// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

/* make sure to keep these in sync with other constants,
e.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */

/* layout contants from \`layout-constants.js\` */

.connection-modal_modal-content_gQMr1 {
    width: 480px;
    line-height: 1.75;
}

.connection-modal_header_LHZG3 {
    background-color: var(--pen-tertiary);
}

.connection-modal_body_ja46q {
    background: var(--ui-modal-background);
}

.connection-modal_label_cKesI {
    font-weight: 500;
    margin: 0 0 0.75rem;
}

.connection-modal_centered-row_Hqbfj {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}

.connection-modal_peripheral-tile-pane_x0R5q {
    overflow-y: auto;
    width: 100%;
    height: 100%;
}

.connection-modal_peripheral-tile_QNmuT {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    background-color: var(--ui-white);
    border-radius: 0.25rem;
    padding: 10px;
    width: 100%;
    height: 55px;
    margin-bottom: 0.5rem;
}

.connection-modal_peripheral-tile-name_bcUjd {
    display: flex;
    align-items: center;
}

[dir="ltr"] .connection-modal_peripheral-tile-image_SUH7X {
    margin-right: 0.5rem;
}

[dir="rtl"] .connection-modal_peripheral-tile-image_SUH7X {
    margin-left: 0.5rem;
}

.connection-modal_peripheral-tile-name-wrapper_dv_38 {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
}

.connection-modal_peripheral-tile-name-label_LKkoY {
    font-weight: bold;
    font-size: 0.625rem;
}

.connection-modal_peripheral-tile-name-text_kyjV3 {
    font-size: 0.875rem;
}

.connection-modal_peripheral-tile_QNmuT button {
    padding: 0.6rem 0.75rem;
    border: none;
    border-radius: 0.25rem;
    font-weight: 600;
    font-size: 0.85rem;
    background: var(--looks-secondary);
    border: var(--looks-secondary);
    color: white;
    cursor: pointer;
}

.connection-modal_signal-strength-meter_Vc8CA {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    width: 22px;
    height: 16px;
}

[dir="ltr"] .connection-modal_signal-strength-meter_Vc8CA {
    margin-right: 1rem;
}

[dir="rtl"] .connection-modal_signal-strength-meter_Vc8CA {
    margin-left: 1rem;
}

.connection-modal_signal-bar_exn4D {
    width: 4px;
    border-radius: 4px;
    background-color: #DBDBDB;
}

.connection-modal_signal-bar_exn4D:nth-of-type(1) { height: 25%; }

.connection-modal_signal-bar_exn4D:nth-of-type(2) { height: 50%; }

.connection-modal_signal-bar_exn4D:nth-of-type(3) { height: 75%; }

.connection-modal_signal-bar_exn4D:nth-of-type(4) { height: 100%; }

.connection-modal_green-bar_OB0IM {
    background-color: var(--pen-primary);
}

.connection-modal_radar-small_faOaX {
    width: 40px;
    height: 40px;
}

[dir="ltr"] .connection-modal_radar-small_faOaX {
    margin-right: 0.5rem;
}

[dir="rtl"] .connection-modal_radar-small_faOaX {
    margin-left: 0.5rem;
}

.connection-modal_radar-big_f8Ola {
    width: 120px;
    height: 120px;
}

.connection-modal_radar-spin_sdm8X {
    animation: connection-modal_spin_DacvZ 4s linear infinite;
}

[dir="ltr"] .connection-modal_radar_UDcUc {
    margin-right: .5rem;
}

[dir="rtl"] .connection-modal_radar_UDcUc {
    margin-left: .5rem;
}

@keyframes connection-modal_spin_DacvZ {
    100% {
        transform: rotate(360deg);
    }
}

.connection-modal_peripheral-activity_yswmi {
    position: relative;
}

.connection-modal_peripheral-activity-icon_cSTH9 {
    /* width: 80px;
    height: 80px; */
}

.connection-modal_connection-tip-icon_k34hl {
    position: absolute;
}

.connection-modal_bluetooth-connecting-icon_qxiDJ {
    position: absolute;
    top: -5px;
    right: -15px;
    left: -15px;
    padding: 5px 5px;
    background-color: var(--looks-secondary);
    border-radius: 100%;
    box-shadow: 0px 0px 0px 4px var(--looks-transparent);
    /* animation: pulse-blue-ring 1s infinite ease-in-out alternate; */
    animation: connection-modal_wiggle_eFEiP 0.5s infinite ease-in-out alternate;

}

@keyframes connection-modal_pulse-blue-ring_cOZlP {
    100% {
        box-shadow: 0px 0px 0px 8px var(--looks-light-transparent);
    }
}

.connection-modal_bluetooth-connected-icon_Tab3e {
    position: absolute;
    top: -5px;
    right: -15px;
    left: -15px;
    padding: 5px 5px;
    background-color: var(--pen-primary);
    border-radius: 100%;
    box-shadow: 0px 0px 0px 4px var(--pen-transparent);
}

@keyframes connection-modal_wiggle_eFEiP {
    0% {transform: rotate(3deg) scale(1.05);}
    25% {transform: rotate(-3deg) scale(1.05);}
    50% {transform: rotate(5deg) scale(1.05);}
    75% {transform: rotate(-2deg) scale(1.05);}
    100% {transform: rotate(0deg) scale(1.05);}
}

.connection-modal_bluetooth-centered-icon_dSdPe {
    position: absolute;
    padding: 5px 5px;
    background-color: var(--looks-secondary);
    border-radius: 100%;
    box-shadow: 0px 0px 0px 2px var(--looks-transparent);
}

.connection-modal_peripheral-tile-widgets_LJpnH {
    display: flex;
    align-items: center;
}

.connection-modal_activityArea_ymXid {
    height: 165px;
    background-color: var(--looks-light-transparent);
    display: flex;
    justify-content: center;
    align-items: center;
    padding: .5rem;
}

.connection-modal_scratch-link-help__yQ0p {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    height: 100%;
    padding-top: .5rem;
    padding-bottom: .5rem;
}

.connection-modal_scratch-link-help-step_NrbbR {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
}

[dir="ltr"] .connection-modal_scratch-link-help-step_NrbbR {
    margin-left: 2.5rem;
}

[dir="rtl"] .connection-modal_scratch-link-help-step_NrbbR {
    margin-right: 2.5rem;
}

.connection-modal_scratch-link-icon_YUSg7 {
    max-width: 50px;
}

.connection-modal_help-step-image_uDQEJ {
    max-width: 40px;
}

[dir="ltr"] .connection-modal_help-step-image_uDQEJ {
    margin-right: 0.5rem;
}

[dir="rtl"] .connection-modal_help-step-image_uDQEJ {
    margin-left: 0.5rem;
}

.connection-modal_help-step-number_vngae {
    background: var(--pen-tertiary);
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--ui-white);
    font-weight: bold;
    min-width: 2rem;
    height: 2rem;
}

[dir="ltr"] .connection-modal_help-step-number_vngae {
    margin-right: 0.5rem;
}

[dir="rtl"] .connection-modal_help-step-number_vngae {
    margin-left: 0.5rem;
}

.connection-modal_button-row_eAovx {
    font-weight: bolder;
    text-align: center;
    display: flex;
}

.connection-modal_abort-connecting-icon_pMYN7 {
    width: 10px;
    transform: rotate(45deg);
}

.connection-modal_connection-button_GaP8j {
    padding: 0.6rem 0.75rem;
    border-radius: 0.5rem;
    background: var(--looks-secondary);
    color: white;
    font-weight: 600;
    font-size: 0.85rem;
    margin: 0.25rem;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
}

.connection-modal_connection-button_GaP8j:disabled {
    background: var(--looks-transparent);
}

.connection-modal_segmented-button_orxMd {
    display: flex;
}

.connection-modal_segmented-button_orxMd .connection-modal_connection-button_GaP8j:first-of-type {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    margin-right: 0;
}

.connection-modal_segmented-button_orxMd .connection-modal_connection-button_GaP8j:last-of-type {
    margin-left: 1px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
}

[dir="ltr"] .connection-modal_button-icon-right_YIjPm {
    margin-left: 0.5rem;
}

[dir="rtl"] .connection-modal_button-icon-right_YIjPm {
    margin-right: 0.5rem;
}

[dir="ltr"] .connection-modal_button-icon-left_qypii {
    margin-right: 0.5rem;
}

[dir="rtl"] .connection-modal_button-icon-left_qypii {
    margin-left: 0.5rem;
}

/* reverse back arrow icon for RTL, don't reverse other connection icons */

[dir="rtl"] .connection-modal_button-icon-back_EBXX8 {
    transform: scaleX(-1);
}

.connection-modal_red-button_EVJax {
    background: var(--red-primary);
}

.connection-modal_corner-buttons_bWV07 {
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 0 1rem;
}

.connection-modal_bottom-area_mn7G9 {
    background-color: var(--ui-modal-background);
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 1rem;
    padding-bottom: .75rem;
    padding-left: .75rem;
    padding-right: .75rem;
}

.connection-modal_bottom-area_mn7G9 .connection-modal_bottom-area-item_RFakl+.connection-modal_bottom-area-item_RFakl {
    margin-top: 1rem;
}

.connection-modal_instructions_b8o9t {
    text-align: center;
}

.connection-modal_dots-row_owgjP {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}

.connection-modal_dots-holder_IruNJ {
    display: flex;
    padding: 0.25rem 0.1rem;
    border-radius: 1rem;
    background: var(--looks-light-transparent);
}

.connection-modal_dots-holder-success_kJ0Fh {
    background: var(--pen-transparent);
}

.connection-modal_dots-holder-error_p4zwt {
    background: var(--error-transparent);
}

.connection-modal_dot_b5t8a {
    width: 0.5rem;
    height: 0.5rem;
    margin: 0 0.3rem;
    border-radius: 100%;
}

.connection-modal_inactive-step-dot_q_jGk {
    background: var(--looks-transparent);
}

.connection-modal_active-step-dot_mjKMM {
    background: var(--looks-secondary);
}

.connection-modal_success-dot_t9rgw {
    background: var(--pen-primary);
}

.connection-modal_error-dot_u1VEW {
    background: var(--error-primary);
}

.connection-modal_scratch-link-error_iznTF {
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    height: 100%;
    padding-top: .5rem;
    padding-bottom: .5rem;
    width: 90%;
}

.connection-modal_scratch-link-error-details_pKxVr {
    display: flex;
    resize: none;
    height: 60%;
    width: inherit;
}
`, "",{"version":3,"sources":["webpack://./src/components/connection-modal/connection-modal.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;sDACsD;;AAEtD,+CAA+C;;AAE/C;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;;IAEnB,iCAAiC;IACjC,sBAAsB;IACtB,aAAa;IACb,WAAW;IACX,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,kCAAkC;IAClC,8BAA8B;IAC9B,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;IACrB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA,oDAA6B,WAAW,EAAE;;AAE1C,oDAA6B,WAAW,EAAE;;AAE1C,oDAA6B,WAAW,EAAE;;AAE1C,oDAA6B,YAAY,EAAE;;AAE3C;IACI,oCAAoC;AACxC;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,yDAAkC;AACtC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI;mBACe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,wCAAwC;IACxC,mBAAmB;IACnB,oDAAoD;IACpD,kEAAkE;IAClE,4EAAqD;;AAEzD;;AAEA;IACI;QACI,0DAA0D;IAC9D;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,oCAAoC;IACpC,mBAAmB;IACnB,kDAAkD;AACtD;;AAEA;IACI,IAAI,mCAAmC,CAAC;IACxC,KAAK,oCAAoC,CAAC;IAC1C,KAAK,mCAAmC,CAAC;IACzC,KAAK,oCAAoC,CAAC;IAC1C,MAAM,mCAAmC,CAAC;AAC9C;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,wCAAwC;IACxC,mBAAmB;IACnB,oDAAoD;AACxD;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,+BAA+B;IAC/B,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,iBAAiB;IACjB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,wBAAwB;AAC5B;;AAEA;IACI,uBAAuB;IACvB,qBAAqB;IACrB,kCAAkC;IAClC,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,0BAA0B;IAC1B,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,0EAA0E;;AAE1E;IACI,qBAAqB;AACzB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,4CAA4C;IAC5C,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;IACjB,sBAAsB;IACtB,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,0CAA0C;AAC9C;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,cAAc;IACd,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,WAAW;IACX,cAAc;AAClB","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n\n/* layout contants from `layout-constants.js` */\n\n.modal-content {\n    width: 480px;\n    line-height: 1.75;\n}\n\n.header {\n    background-color: var(--pen-tertiary);\n}\n\n.body {\n    background: var(--ui-modal-background);\n}\n\n.label {\n    font-weight: 500;\n    margin: 0 0 0.75rem;\n}\n\n.centered-row {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n}\n\n.peripheral-tile-pane {\n    overflow-y: auto;\n    width: 100%;\n    height: 100%;\n}\n\n.peripheral-tile {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n\n    background-color: var(--ui-white);\n    border-radius: 0.25rem;\n    padding: 10px;\n    width: 100%;\n    height: 55px;\n    margin-bottom: 0.5rem;\n}\n\n.peripheral-tile-name {\n    display: flex;\n    align-items: center;\n}\n\n[dir=\"ltr\"] .peripheral-tile-image {\n    margin-right: 0.5rem;\n}\n\n[dir=\"rtl\"] .peripheral-tile-image {\n    margin-left: 0.5rem;\n}\n\n.peripheral-tile-name-wrapper {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: flex-start;\n}\n\n.peripheral-tile-name-label {\n    font-weight: bold;\n    font-size: 0.625rem;\n}\n\n.peripheral-tile-name-text {\n    font-size: 0.875rem;\n}\n\n.peripheral-tile button {\n    padding: 0.6rem 0.75rem;\n    border: none;\n    border-radius: 0.25rem;\n    font-weight: 600;\n    font-size: 0.85rem;\n    background: var(--looks-secondary);\n    border: var(--looks-secondary);\n    color: white;\n    cursor: pointer;\n}\n\n.signal-strength-meter {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-end;\n    width: 22px;\n    height: 16px;\n}\n\n[dir=\"ltr\"] .signal-strength-meter {\n    margin-right: 1rem;\n}\n\n[dir=\"rtl\"] .signal-strength-meter {\n    margin-left: 1rem;\n}\n\n.signal-bar {\n    width: 4px;\n    border-radius: 4px;\n    background-color: #DBDBDB;\n}\n\n.signal-bar:nth-of-type(1) { height: 25%; }\n\n.signal-bar:nth-of-type(2) { height: 50%; }\n\n.signal-bar:nth-of-type(3) { height: 75%; }\n\n.signal-bar:nth-of-type(4) { height: 100%; }\n\n.green-bar {\n    background-color: var(--pen-primary);\n}\n\n.radar-small {\n    width: 40px;\n    height: 40px;\n}\n\n[dir=\"ltr\"] .radar-small {\n    margin-right: 0.5rem;\n}\n\n[dir=\"rtl\"] .radar-small {\n    margin-left: 0.5rem;\n}\n\n.radar-big {\n    width: 120px;\n    height: 120px;\n}\n\n.radar-spin {\n    animation: spin 4s linear infinite;\n}\n\n[dir=\"ltr\"] .radar {\n    margin-right: .5rem;\n}\n\n[dir=\"rtl\"] .radar {\n    margin-left: .5rem;\n}\n\n@keyframes spin {\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n.peripheral-activity {\n    position: relative;\n}\n\n.peripheral-activity-icon {\n    /* width: 80px;\n    height: 80px; */\n}\n\n.connection-tip-icon {\n    position: absolute;\n}\n\n.bluetooth-connecting-icon {\n    position: absolute;\n    top: -5px;\n    right: -15px;\n    left: -15px;\n    padding: 5px 5px;\n    background-color: var(--looks-secondary);\n    border-radius: 100%;\n    box-shadow: 0px 0px 0px 4px var(--looks-transparent);\n    /* animation: pulse-blue-ring 1s infinite ease-in-out alternate; */\n    animation: wiggle 0.5s infinite ease-in-out alternate;\n\n}\n\n@keyframes pulse-blue-ring {\n    100% {\n        box-shadow: 0px 0px 0px 8px var(--looks-light-transparent);\n    }\n}\n\n.bluetooth-connected-icon {\n    position: absolute;\n    top: -5px;\n    right: -15px;\n    left: -15px;\n    padding: 5px 5px;\n    background-color: var(--pen-primary);\n    border-radius: 100%;\n    box-shadow: 0px 0px 0px 4px var(--pen-transparent);\n}\n\n@keyframes wiggle {\n    0% {transform: rotate(3deg) scale(1.05);}\n    25% {transform: rotate(-3deg) scale(1.05);}\n    50% {transform: rotate(5deg) scale(1.05);}\n    75% {transform: rotate(-2deg) scale(1.05);}\n    100% {transform: rotate(0deg) scale(1.05);}\n}\n\n.bluetooth-centered-icon {\n    position: absolute;\n    padding: 5px 5px;\n    background-color: var(--looks-secondary);\n    border-radius: 100%;\n    box-shadow: 0px 0px 0px 2px var(--looks-transparent);\n}\n\n.peripheral-tile-widgets {\n    display: flex;\n    align-items: center;\n}\n\n.activityArea {\n    height: 165px;\n    background-color: var(--looks-light-transparent);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: .5rem;\n}\n\n.scratch-link-help {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-around;\n    height: 100%;\n    padding-top: .5rem;\n    padding-bottom: .5rem;\n}\n\n.scratch-link-help-step {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n    align-items: center;\n}\n\n[dir=\"ltr\"] .scratch-link-help-step {\n    margin-left: 2.5rem;\n}\n\n[dir=\"rtl\"] .scratch-link-help-step {\n    margin-right: 2.5rem;\n}\n\n.scratch-link-icon {\n    max-width: 50px;\n}\n\n.help-step-image {\n    max-width: 40px;\n}\n\n[dir=\"ltr\"] .help-step-image {\n    margin-right: 0.5rem;\n}\n\n[dir=\"rtl\"] .help-step-image {\n    margin-left: 0.5rem;\n}\n\n.help-step-number {\n    background: var(--pen-tertiary);\n    border-radius: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: var(--ui-white);\n    font-weight: bold;\n    min-width: 2rem;\n    height: 2rem;\n}\n\n[dir=\"ltr\"] .help-step-number {\n    margin-right: 0.5rem;\n}\n\n[dir=\"rtl\"] .help-step-number {\n    margin-left: 0.5rem;\n}\n\n.button-row {\n    font-weight: bolder;\n    text-align: center;\n    display: flex;\n}\n\n.abort-connecting-icon {\n    width: 10px;\n    transform: rotate(45deg);\n}\n\n.connection-button {\n    padding: 0.6rem 0.75rem;\n    border-radius: 0.5rem;\n    background: var(--looks-secondary);\n    color: white;\n    font-weight: 600;\n    font-size: 0.85rem;\n    margin: 0.25rem;\n    border: none;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n}\n\n.connection-button:disabled {\n    background: var(--looks-transparent);\n}\n\n.segmented-button {\n    display: flex;\n}\n\n.segmented-button .connection-button:first-of-type {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n    margin-right: 0;\n}\n\n.segmented-button .connection-button:last-of-type {\n    margin-left: 1px;\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n}\n\n[dir=\"ltr\"] .button-icon-right {\n    margin-left: 0.5rem;\n}\n\n[dir=\"rtl\"] .button-icon-right {\n    margin-right: 0.5rem;\n}\n\n[dir=\"ltr\"] .button-icon-left {\n    margin-right: 0.5rem;\n}\n\n[dir=\"rtl\"] .button-icon-left {\n    margin-left: 0.5rem;\n}\n\n/* reverse back arrow icon for RTL, don't reverse other connection icons */\n\n[dir=\"rtl\"] .button-icon-back {\n    transform: scaleX(-1);\n}\n\n.red-button {\n    background: var(--red-primary);\n}\n\n.corner-buttons {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n    padding: 0 1rem;\n}\n\n.bottom-area {\n    background-color: var(--ui-modal-background);\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding-top: 1rem;\n    padding-bottom: .75rem;\n    padding-left: .75rem;\n    padding-right: .75rem;\n}\n\n.bottom-area .bottom-area-item+.bottom-area-item {\n    margin-top: 1rem;\n}\n\n.instructions {\n    text-align: center;\n}\n\n.dots-row {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n}\n\n.dots-holder {\n    display: flex;\n    padding: 0.25rem 0.1rem;\n    border-radius: 1rem;\n    background: var(--looks-light-transparent);\n}\n\n.dots-holder-success {\n    background: var(--pen-transparent);\n}\n\n.dots-holder-error {\n    background: var(--error-transparent);\n}\n\n.dot {\n    width: 0.5rem;\n    height: 0.5rem;\n    margin: 0 0.3rem;\n    border-radius: 100%;\n}\n\n.inactive-step-dot {\n    background: var(--looks-transparent);\n}\n\n.active-step-dot {\n    background: var(--looks-secondary);\n}\n\n.success-dot {\n    background: var(--pen-primary);\n}\n\n.error-dot {\n    background: var(--error-primary);\n}\n\n.scratch-link-error {\n    align-items: center;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-around;\n    height: 100%;\n    padding-top: .5rem;\n    padding-bottom: .5rem;\n    width: 90%;\n}\n\n.scratch-link-error-details {\n    display: flex;\n    resize: none;\n    height: 60%;\n    width: inherit;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal-content": `connection-modal_modal-content_gQMr1`,
	"modalContent": `connection-modal_modal-content_gQMr1`,
	"header": `connection-modal_header_LHZG3`,
	"body": `connection-modal_body_ja46q`,
	"label": `connection-modal_label_cKesI`,
	"centered-row": `connection-modal_centered-row_Hqbfj`,
	"centeredRow": `connection-modal_centered-row_Hqbfj`,
	"peripheral-tile-pane": `connection-modal_peripheral-tile-pane_x0R5q`,
	"peripheralTilePane": `connection-modal_peripheral-tile-pane_x0R5q`,
	"peripheral-tile": `connection-modal_peripheral-tile_QNmuT`,
	"peripheralTile": `connection-modal_peripheral-tile_QNmuT`,
	"peripheral-tile-name": `connection-modal_peripheral-tile-name_bcUjd`,
	"peripheralTileName": `connection-modal_peripheral-tile-name_bcUjd`,
	"peripheral-tile-image": `connection-modal_peripheral-tile-image_SUH7X`,
	"peripheralTileImage": `connection-modal_peripheral-tile-image_SUH7X`,
	"peripheral-tile-name-wrapper": `connection-modal_peripheral-tile-name-wrapper_dv_38`,
	"peripheralTileNameWrapper": `connection-modal_peripheral-tile-name-wrapper_dv_38`,
	"peripheral-tile-name-label": `connection-modal_peripheral-tile-name-label_LKkoY`,
	"peripheralTileNameLabel": `connection-modal_peripheral-tile-name-label_LKkoY`,
	"peripheral-tile-name-text": `connection-modal_peripheral-tile-name-text_kyjV3`,
	"peripheralTileNameText": `connection-modal_peripheral-tile-name-text_kyjV3`,
	"signal-strength-meter": `connection-modal_signal-strength-meter_Vc8CA`,
	"signalStrengthMeter": `connection-modal_signal-strength-meter_Vc8CA`,
	"signal-bar": `connection-modal_signal-bar_exn4D`,
	"signalBar": `connection-modal_signal-bar_exn4D`,
	"green-bar": `connection-modal_green-bar_OB0IM`,
	"greenBar": `connection-modal_green-bar_OB0IM`,
	"radar-small": `connection-modal_radar-small_faOaX`,
	"radarSmall": `connection-modal_radar-small_faOaX`,
	"radar-big": `connection-modal_radar-big_f8Ola`,
	"radarBig": `connection-modal_radar-big_f8Ola`,
	"radar-spin": `connection-modal_radar-spin_sdm8X`,
	"radarSpin": `connection-modal_radar-spin_sdm8X`,
	"spin": `connection-modal_spin_DacvZ`,
	"radar": `connection-modal_radar_UDcUc`,
	"peripheral-activity": `connection-modal_peripheral-activity_yswmi`,
	"peripheralActivity": `connection-modal_peripheral-activity_yswmi`,
	"peripheral-activity-icon": `connection-modal_peripheral-activity-icon_cSTH9`,
	"peripheralActivityIcon": `connection-modal_peripheral-activity-icon_cSTH9`,
	"connection-tip-icon": `connection-modal_connection-tip-icon_k34hl`,
	"connectionTipIcon": `connection-modal_connection-tip-icon_k34hl`,
	"bluetooth-connecting-icon": `connection-modal_bluetooth-connecting-icon_qxiDJ`,
	"bluetoothConnectingIcon": `connection-modal_bluetooth-connecting-icon_qxiDJ`,
	"wiggle": `connection-modal_wiggle_eFEiP`,
	"bluetooth-connected-icon": `connection-modal_bluetooth-connected-icon_Tab3e`,
	"bluetoothConnectedIcon": `connection-modal_bluetooth-connected-icon_Tab3e`,
	"bluetooth-centered-icon": `connection-modal_bluetooth-centered-icon_dSdPe`,
	"bluetoothCenteredIcon": `connection-modal_bluetooth-centered-icon_dSdPe`,
	"peripheral-tile-widgets": `connection-modal_peripheral-tile-widgets_LJpnH`,
	"peripheralTileWidgets": `connection-modal_peripheral-tile-widgets_LJpnH`,
	"activityArea": `connection-modal_activityArea_ymXid`,
	"scratch-link-help": `connection-modal_scratch-link-help__yQ0p`,
	"scratchLinkHelp": `connection-modal_scratch-link-help__yQ0p`,
	"scratch-link-help-step": `connection-modal_scratch-link-help-step_NrbbR`,
	"scratchLinkHelpStep": `connection-modal_scratch-link-help-step_NrbbR`,
	"scratch-link-icon": `connection-modal_scratch-link-icon_YUSg7`,
	"scratchLinkIcon": `connection-modal_scratch-link-icon_YUSg7`,
	"help-step-image": `connection-modal_help-step-image_uDQEJ`,
	"helpStepImage": `connection-modal_help-step-image_uDQEJ`,
	"help-step-number": `connection-modal_help-step-number_vngae`,
	"helpStepNumber": `connection-modal_help-step-number_vngae`,
	"button-row": `connection-modal_button-row_eAovx`,
	"buttonRow": `connection-modal_button-row_eAovx`,
	"abort-connecting-icon": `connection-modal_abort-connecting-icon_pMYN7`,
	"abortConnectingIcon": `connection-modal_abort-connecting-icon_pMYN7`,
	"connection-button": `connection-modal_connection-button_GaP8j`,
	"connectionButton": `connection-modal_connection-button_GaP8j`,
	"segmented-button": `connection-modal_segmented-button_orxMd`,
	"segmentedButton": `connection-modal_segmented-button_orxMd`,
	"button-icon-right": `connection-modal_button-icon-right_YIjPm`,
	"buttonIconRight": `connection-modal_button-icon-right_YIjPm`,
	"button-icon-left": `connection-modal_button-icon-left_qypii`,
	"buttonIconLeft": `connection-modal_button-icon-left_qypii`,
	"button-icon-back": `connection-modal_button-icon-back_EBXX8`,
	"buttonIconBack": `connection-modal_button-icon-back_EBXX8`,
	"red-button": `connection-modal_red-button_EVJax`,
	"redButton": `connection-modal_red-button_EVJax`,
	"corner-buttons": `connection-modal_corner-buttons_bWV07`,
	"cornerButtons": `connection-modal_corner-buttons_bWV07`,
	"bottom-area": `connection-modal_bottom-area_mn7G9`,
	"bottomArea": `connection-modal_bottom-area_mn7G9`,
	"bottom-area-item": `connection-modal_bottom-area-item_RFakl`,
	"bottomAreaItem": `connection-modal_bottom-area-item_RFakl`,
	"instructions": `connection-modal_instructions_b8o9t`,
	"dots-row": `connection-modal_dots-row_owgjP`,
	"dotsRow": `connection-modal_dots-row_owgjP`,
	"dots-holder": `connection-modal_dots-holder_IruNJ`,
	"dotsHolder": `connection-modal_dots-holder_IruNJ`,
	"dots-holder-success": `connection-modal_dots-holder-success_kJ0Fh`,
	"dotsHolderSuccess": `connection-modal_dots-holder-success_kJ0Fh`,
	"dots-holder-error": `connection-modal_dots-holder-error_p4zwt`,
	"dotsHolderError": `connection-modal_dots-holder-error_p4zwt`,
	"dot": `connection-modal_dot_b5t8a`,
	"inactive-step-dot": `connection-modal_inactive-step-dot_q_jGk`,
	"inactiveStepDot": `connection-modal_inactive-step-dot_q_jGk`,
	"active-step-dot": `connection-modal_active-step-dot_mjKMM`,
	"activeStepDot": `connection-modal_active-step-dot_mjKMM`,
	"success-dot": `connection-modal_success-dot_t9rgw`,
	"successDot": `connection-modal_success-dot_t9rgw`,
	"error-dot": `connection-modal_error-dot_u1VEW`,
	"errorDot": `connection-modal_error-dot_u1VEW`,
	"scratch-link-error": `connection-modal_scratch-link-error_iznTF`,
	"scratchLinkError": `connection-modal_scratch-link-error_iznTF`,
	"scratch-link-error-details": `connection-modal_scratch-link-error-details_pKxVr`,
	"scratchLinkErrorDetails": `connection-modal_scratch-link-error-details_pKxVr`,
	"pulse-blue-ring": `connection-modal_pulse-blue-ring_cOZlP`,
	"pulseBlueRing": `connection-modal_pulse-blue-ring_cOZlP`
};
export default ___CSS_LOADER_EXPORT___;
